export default __webpack_public_path__ + "static/media/call-now.466464ff.svg";